import React from "react";
import { ThemeProvider } from "styled-components";
import { setGlobal } from "reactn";

const variables = () =>
	require('sass-extract-loader?{"plugins": ["sass-extract-js"]}!../../../../scss/_variables.scss');

export const theme = (currentTheme) => {
	return variables().themes[currentTheme];
};

export const AppThemeContextProviderWrapper = ({ currentTheme, children }) => {
	setGlobal({
		theme: theme(currentTheme),
	});
	return <ThemeProvider theme={theme(currentTheme)}>{children}</ThemeProvider>;
};

export default AppThemeContextProviderWrapper;
